import { CheggTlds } from './constants';
/** CheggTld type predicate */
function isCheggTld(tld) {
  return Object.values(CheggTlds).some(function (val) {
    return tld === val;
  });
}
export default isCheggTld;